import React from "react";
import clsx from "clsx";
import { IconMaterial } from "../../iconMaterial/IconMaterial";

export interface FilterButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    label: string;
    active?: boolean;
    clearable?: boolean;
    icon: string;
    onClear?: () => void;
}

const FilterButton: React.FC<FilterButtonProps> = ({
    label,
    active = false,
    clearable = false,
    icon,
    onClear,
    className,
    ...props
}) => {
    return (
        <div className="inline-flex items-center">
            <button
                className={clsx(
                    "px-3 py-2 bg-white rounded-lg rounded-bl-lg border border-secondary-light hover:border-primary-default flex items-center gap-2 transition-colors",
                    active
                        ? "text-primary"
                        : "text-secondary-dark",
                    className
                )}
                {...props}
            >
                <span
                    className={clsx(
                        "flex items-center justify-center mr-[-20px]",
                        active ? "text-primeblue" : "text-primary-light"
                    )}
                >
                    <IconMaterial
                        filled
                        icon={icon}
                        size={20}
                        className={active ? "text-primeblue" : "text-primary-light"}
                    />
                </span>

                <span
                    className={clsx(
                        "flex items-center gap-1 text-sm font-medium font-sans hover:text-primary-light",
                        active ? "text-primeblue" : "text-primary-light"
                    )}
                >
                    <span>{label}</span>
                </span>

                {clearable && onClear && (
                    <IconMaterial
                        filled
                        icon="close"
                        className="cursor-pointer"
                        size={20}
                        onClick={(e) => {
                            e.stopPropagation();
                            onClear();
                        }}
                    />
                )}
            </button>
        </div>
    );
};

export default FilterButton;
